import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as pageActions from '../../../actions/page';
import Loading from '../../../components/loading';
import AdminItemPageContainer from '../admin-item-page-container';
import LocalizedStrings from '../../../localization/strings';
import PageForm from '../../../components/page/page-form';

class PartnerContainer extends AdminItemPageContainer {

    getBaseUrl() {
        return '/admin/pages';
    }

    fetchItem(id) {
        return this.props.actions.fetchPage(id)
    }

    render() {
        const {actions, loading} = this.props;

        return (
            <div className="panel">
                <header className="panel-header">{LocalizedStrings.pageEdit}</header>
                <div className="panel-body">
                    {loading
                        ? <Loading/>
                        : <PageForm submit={actions.submitPage} onSuccessSubmit={this.onSuccessSubmit.bind(this)}></PageForm>
}
                </div>
            </div>
        )

    }
}

export default connect(function(state) {
    return {loading: state.page.loading};
}, function(dispatch) {
    return {
        actions: bindActionCreators({
            ...pageActions
        }, dispatch)
    };
})(PartnerContainer);



// WEBPACK FOOTER //
// ./src/js/containers/admin/page/page-container.js